<footer fxFlex>
  <ng-content select=".ngcontent-select-footer"></ng-content>
</footer>
